import PropTypes from 'prop-types';

export const FormGroupPropType = PropTypes.shape({
    uniqueName: PropTypes.any,
    parent: PropTypes.any,
    collection: PropTypes.any,
});
